import { initializeApp } from 'firebase/app';
import { getFirestore, enableMultiTabIndexedDbPersistence, doc, getDocFromServer } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyBQ1CO4ZzCVecXgN8Cn6Idvrmudm7y-lbA",
  authDomain: "q-home2.firebaseapp.com",
  projectId: "q-home2",
  storageBucket: "q-home2.firebasestorage.app",
  messagingSenderId: "761941461134",
  appId: "1:761941461134:web:8ace84c20573a27700e1df"
};

// 1. Initialize App
const app = initializeApp(firebaseConfig);

// 2. Initialize Firestore
const db = getFirestore(app);

// Validate Connection to Firestore
async function testConnection() {
  try {
    // Try to fetch a non-existent doc just to test connectivity
    await getDocFromServer(doc(db, '_internal_', 'connection_test'));
    console.log("[Firebase] Connection test successful.");
  } catch (error) {
    if (error instanceof Error && error.message.includes('the client is offline')) {
      console.error("🔥 [Firebase] Connection Error: The client is offline. Please check if your domain is authorized in Firebase Console.");
    } else {
      console.warn("[Firebase] Connection test warning (expected if doc doesn't exist):", error);
    }
  }
}

if (typeof window !== 'undefined') {
    testConnection();
}

// Enable persistence for quota optimization
if (typeof window !== 'undefined') {
    enableMultiTabIndexedDbPersistence(db).catch((err) => {
        if (err.code === 'failed-precondition') {
            // Multiple tabs open, persistence can only be enabled in one tab at a a time.
            console.warn('Firestore persistence failed: multiple tabs open');
        } else if (err.code === 'unimplemented') {
            // The current browser does not support all of the features required to enable persistence
            console.warn('Firestore persistence is not supported by this browser');
        }
    });
}

// 3. Initialize Auth
const auth = getAuth(app);

// 4. Initialize Messaging
// Handle environments where service workers might not be supported (e.g., some dev modes or non-HTTPS localhost)
let messaging: any = null;
try {
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
        messaging = getMessaging(app);
    }
} catch (err) {
    console.warn("Firebase Messaging failed to initialize:", err);
}

const VAPID_KEY = "BABQ1CfvtLt5ufsa-qOjtA5rGdfvlk8S7JwybGCMmnc2YR9FU44qz-oGXZdxBcLlzkExjPt5eR-2W6WVeV-juX58";

export const requestForToken = async () => {
    if (!messaging) return null;
    try {
        const currentToken = await getToken(messaging, { vapidKey: VAPID_KEY });
        if (currentToken) {
            return currentToken;
        } else {
            console.log('No registration token available. Request permission to generate one.');
            return null;
        }
    } catch (err) {
        console.log('An error occurred while retrieving token. ', err);
        return null;
    }
};

export const onMessageListener = () =>
    new Promise((resolve) => {
        if (!messaging) return;
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });

export { db, auth, app, messaging };